const durationTokenPattern = /(-?\d+(?:[.,]\d+)?)\s*(d|day|days|д|дн|день|дня|дней|h|hr|hrs|hour|hours|ч|час|часа|часов|m|min|mins|minute|minutes|м|мин|минута|минуты|минут|s|sec|secs|second|seconds|с|сек|секунда|секунды|секунд)/gi;

export function parseDurationToSeconds(input: string) {
  const normalized = input.trim().toLowerCase().replace(",", ".");
  if (normalized === "") {
    return "";
  }

  if (/^\d+(?:\.\d+)?$/.test(normalized)) {
    return String(Math.round(Number(normalized)));
  }

  const clockMatch = normalized.match(/^(\d+):([0-5]\d)(?::([0-5]\d))?$/);
  if (clockMatch) {
    const first = Number(clockMatch[1]);
    const second = Number(clockMatch[2]);
    const third = clockMatch[3] ? Number(clockMatch[3]) : null;
    return String(third === null ? first * 3600 + second * 60 : first * 3600 + second * 60 + third);
  }

  let totalSeconds = 0;
  let matchedLength = 0;
  durationTokenPattern.lastIndex = 0;
  for (const match of normalized.matchAll(durationTokenPattern)) {
    const amount = Number(match[1]);
    const unit = match[2];
    if (!unit || !Number.isFinite(amount) || amount < 0) {
      return null;
    }
    matchedLength += match[0].length;
    totalSeconds += amount * durationUnitSeconds(unit);
  }

  if (matchedLength === 0 || normalized.replace(durationTokenPattern, "").trim() !== "") {
    return null;
  }

  return String(Math.round(totalSeconds));
}

export function formatDurationFromSeconds(value: string | number | null | undefined) {
  const seconds = typeof value === "number" ? value : Number(value);
  if (!Number.isFinite(seconds) || seconds <= 0) {
    return "";
  }

  const wholeSeconds = Math.round(seconds);
  const days = Math.floor(wholeSeconds / 86400);
  const hours = Math.floor((wholeSeconds % 86400) / 3600);
  const minutes = Math.floor((wholeSeconds % 3600) / 60);
  const remainingSeconds = wholeSeconds % 60;
  const parts: string[] = [];

  if (days > 0) {
    parts.push(`${days}d`);
  }
  if (hours > 0) {
    parts.push(`${hours}h`);
  }
  if (minutes > 0) {
    parts.push(`${minutes}m`);
  }
  if (remainingSeconds > 0 || parts.length === 0) {
    parts.push(`${remainingSeconds}s`);
  }

  return parts.join(" ");
}

function durationUnitSeconds(unit: string) {
  const normalized = unit.toLowerCase();
  if (["d", "day", "days", "д", "дн", "день", "дня", "дней"].includes(normalized)) {
    return 86400;
  }
  if (["h", "hr", "hrs", "hour", "hours", "ч", "час", "часа", "часов"].includes(normalized)) {
    return 3600;
  }
  if (["m", "min", "mins", "minute", "minutes", "м", "мин", "минута", "минуты", "минут"].includes(normalized)) {
    return 60;
  }
  return 1;
}
